import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const InquiryDialog = ({ ad, open, onOpenChange }) => {
  const { t } = useApp();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!ad) return;
    setSending(true);
    try {
      await api.post("/messages", { ad_id: ad.id, ...form });
      toast.success(t("inquiry_sent"));
      setForm({ name: "", email: "", message: "" });
      onOpenChange(false);
    } catch (err) {
      toast.error(t("inquiry_error"));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="inquiry-dialog" className="rounded-none bg-[color:var(--c-bg)] border-[color:var(--c-ink)] max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-serif text-3xl">{t("inquire_title")}</DialogTitle>
          <DialogDescription className="text-[color:var(--c-ink2)]">
            {ad ? ad.title : ""} — {t("inquire_sub")}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <Input
            data-testid="inquiry-name" required placeholder={t("your_name")}
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="rounded-none bg-[color:var(--c-surface)] border-[color:var(--c-border)] h-12"
          />
          <Input
            data-testid="inquiry-email" required type="email" placeholder={t("your_email")}
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="rounded-none bg-[color:var(--c-surface)] border-[color:var(--c-border)] h-12"
          />
          <Textarea
            data-testid="inquiry-message" required placeholder={t("your_message")} rows={4}
            value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="rounded-none bg-[color:var(--c-surface)] border-[color:var(--c-border)]"
          />
          <button
            data-testid="inquiry-submit-button" type="submit" disabled={sending}
            className="w-full bg-[color:var(--c-dark)] text-[color:var(--c-on-dark)] hover:bg-[color:var(--c-accent)] transition-colors py-3 text-sm tracking-[0.15em] uppercase font-semibold disabled:opacity-60"
          >
            {sending ? t("sending") : t("send")}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
